import React from "react";

export const Hr: React.FC = () => {
  return (
    <div
      className="border-bottom border-dark mx-auto m-4"
      style={{width: "20px"}}
    />
  )
}